import React from "react";
import Checkbox from "../Checkbox";
import toDisplayCase from "../../utils/toDisplayCase";

function Head({
  selectable,
  fields,
  excludeFields,
  actionsList,
  selected,
  onSelectAll,
  objects,
}) {
  return (
    <tr>
      {selectable && (
        <th className="">
          <Checkbox
            className="align-middle"
            id="check_all"
            checked={objects.length === selected.length && objects.length !== 0}
            onChange={(checked) => onSelectAll(checked)}
          />
        </th>
      )}
      {Object.keys(fields).map((field, index) => {
        const isLast = index === Object.keys(fields).length - 1;
        const isFirst = index === 0;

        const { type, ...options } = fields[field];
        const label = options.label || toDisplayCase(field);

        return (
          <th
            key={field}
            className="fs-xs text-nowrap align-middle text-center bg-primary text-white"
            style={{
              height: "3rem",
              borderTopLeftRadius: isFirst ? ".25rem" : 0,
              borderTopRightRadius: isLast ? ".25rem" : 0,
            }}
          >
            {label}
          </th>
        );
      })}
      <th
        className="fs-xs align-middle text-nowrap"
        style={{ backgroundColor: "#04376a", color: "white" }}
      >
        <div style={{ width: "50px" }}>Client</div>
      </th>
      <th
        className="fs-xs align-middle text-nowrap"
        style={{ backgroundColor: "#04376a", color: "white" }}
      >
        <div style={{ width: "50px" }}>Branch</div>
      </th>
      {actionsList.length > 0 && (
        <>
          <th>
            <div style={{ width: "50px" }}></div>
          </th>
          <th
            className="fs-xs align-middle text-nowrap"
            colSpan={actionsList.length}
          >
            ACTIONS
          </th>
        </>
      )}
    </tr>
  );
}

export default Head;
